import { useState, useEffect } from 'react'

export function GoUpButton() {
    const [isVisible, setIsVisible] = useState(false)

    useEffect(() => {
        const handleScroll = () => {
            const scrollY = window.scrollY
            const screenHeight = window.innerHeight
            const scrollThreshold = screenHeight * 0.3

            setIsVisible(scrollY > scrollThreshold)
        };

        window.addEventListener('scroll', handleScroll)

        return () => {
            window.removeEventListener('scroll', handleScroll)
        }
    }, [])

    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' })
    };

    return (
        <button
            onClick={scrollToTop}
            className={`fixed bottom-[1rem] right-[0.8rem] z-50 p-[0.8rem] bg-primary text-white rounded-full shadow-lg transition-all duration-300 ease-in-out hover:shadow-2xl ${isVisible ? 'visible' : 'invisible'}`}
            style={{
                transitionProperty: 'opacity, visibility',
                transitionTimingFunction: 'ease-in-out',
                opacity: isVisible ? 1 : 0,
                visibility: isVisible ? 'visible' : 'hidden'
            }}
        >
            <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-[0.8rem] w-[0.8rem]"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
            >
                <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M5 10l7-7m0 0l7 7m-7-7v18"
                />
            </svg>
        </button>
    )
}